"use client";
const en = {
  components: {
    feedback: {
      alerts: {
        dismissLabel: "Close"
      }
    },
    surfaces: {
      modal: {
        dismissLabel: "Close"
      }
    },
    inputs: {
      pickers: {
        calendar: {
          calendar: "Calendar",
          showPreviousMonth: "Show previous month",
          showNextMonth: "Show next month",
          shortDayNames: {
            mon: "Mon",
            tue: "Tue",
            wed: "Wed",
            thu: "Thu",
            fri: "Fri",
            sat: "Sat",
            sun: "Sun"
          },
          monthNames: {
            1: "January",
            2: "February",
            3: "March",
            4: "April",
            5: "May",
            6: "June",
            7: "July",
            8: "August",
            9: "September",
            10: "October",
            11: "November",
            12: "December"
          }
        }
      }
    }
  },
  validation: {
    defaultRequiredError: "Please fill out this field",
    required: "Required",
    optional: "Optional",
    characters: "characters",
    digits: "digits",
    errors: {
      invalidCharacters: "Contains invalid characters.",
      onlyDigits: "Can only contain digits.",
      invalidEmail: "Invalid email address.",
      invalidName: "Invalid name.",
      invalidNameRegex: "Can only contain letters, spaces, apostrophes and hyphens.",
      invalidPhoneNumber: "Invalid phone number.",
      invalidCellPhoneFirstDigit: "The first digit must be 4 or 9.",
      invalidRegistrationNumber: "Must consist of 2 letters and 5 digits. Example: AB12345",
      invalidLength: (length, characterType) => `Must consist of ${length} ${characterType}.`,
      invalidMaxLength: (maxLength, characterType) => `Cannot be longer than ${maxLength} ${characterType}.`
    }
  },
  form: {
    fieldNecessityPreamble: {
      allFieldsRequired: "All fields are required",
      allFieldsOptional: "All fields are optional",
      allFieldsRequiredUnless: "All fields are required unless otherwise specified",
      allFieldsOptionalUnless: "All fields are optional unless otherwise specified"
    }
  }
};
export {
  en
};
